import { useState } from 'react';
import {
  ModalDialogComponent,
  ModalDialogComponentProps,
} from '~/shared/components';
import { CaptionButton } from '~/shared/components/ui/Button';
import { useLoading } from '~/shared/contexts/LoadingProvider';

export const UISamplePageLoading = () => {
  const [isShowDialog, setShowDialog] = useState(false);

  const { showLoading, hideLoading } = useLoading();
  const handleLoading = () => {
    showLoading();
    setTimeout(() => hideLoading(), 1000);
  };

  const handleShowCloseDialog = () => {
    showLoading();
    setTimeout(() => setShowDialog(true), 1000);
    setTimeout(() => setShowDialog(false), 2000);
    setTimeout(() => hideLoading(), 3000);
  };

  return (
    <div className="categories">
      <h3 id="loading">
        ローディング
        <br />
        <small></small>
      </h3>
      <p></p>
      <div className="input-line">
        <div className="item-group-100">
          <div className="w-100">
            <CaptionButton
              buttonType="basic"
              caption="ローディング表示"
              name=""
              onClick={handleLoading}
            />
            <CaptionButton
              buttonType="basic"
              caption="ダイアログを表示"
              name=""
              onClick={() => {
                setShowDialog(true);
              }}
            />
            <CaptionButton
              buttonType="basic"
              caption="ローディング中にダイアログを表示して閉じる"
              name=""
              onClick={handleShowCloseDialog}
            />
            <SampleDialog
              isOpen={isShowDialog}
              onCancel={() => {
                setShowDialog(false);
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

interface SampleDialogProps {
  isOpen: boolean;
  onCancel: () => void;
}
const SampleDialog = ({ isOpen, onCancel }: SampleDialogProps) => {
  const { showLoading, hideLoading } = useLoading();
  const handleLoading = () => {
    showLoading();
    setTimeout(() => {
      hideLoading();
    }, 1000);
  };
  const openModalProps: ModalDialogComponentProps = {
    cancel: onCancel,
    send: () => {},
    modalIsOpen: isOpen,
    headerLabelId: {},
    messageLabelId: {},
    elements: (
      <>
        <div>
          <CaptionButton
            buttonType="basic"
            caption="ローディング表示"
            name=""
            onClick={handleLoading}
          />
        </div>
        <div className="button-area">
          <CaptionButton
            name="cancelBtn"
            buttonType="cancel"
            className="button"
            caption="閉じる"
            onClick={onCancel}
          />
        </div>
      </>
    ),
  };
  return <ModalDialogComponent {...openModalProps} />;
};
